import { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Button } from '../ui/button';
import { toast } from 'sonner';

export default function ClientInfoModal({ client, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    entreprise: client.entreprise || '',
    secteur: client.secteur || '',
    pays: client.pays || 'Guinée',
    ville: client.ville || '',
    adresse: client.adresse || '',
    site_web: client.site_web || '',
    telephone: client.telephone || '',
    taille_entreprise: client.taille_entreprise || 'PME',
    statut: client.statut || 'Prospect',
    commercial: client.commercial || ''
  });

  const handleSubmit = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/clients/${client.id}/extended`,
        formData
      );
      toast.success('Informations mises à jour');
      onSuccess();
    } catch (error) {
      console.error('Error updating client:', error);
      toast.error('Erreur lors de la mise à jour');
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Modifier les informations</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <Label>Nom de l'entreprise *</Label>
            <Input
              value={formData.entreprise}
              onChange={(e) => setFormData({ ...formData, entreprise: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Secteur d'activité *</Label>
              <Input
                value={formData.secteur}
                onChange={(e) => setFormData({ ...formData, secteur: e.target.value })}
                placeholder="Télécommunications, Banque..."
              />
            </div>
            <div>
              <Label>Statut *</Label>
              <Select
                value={formData.statut}
                onValueChange={(val) => setFormData({ ...formData, statut: val })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Prospect">Prospect</SelectItem>
                  <SelectItem value="Actif">Actif</SelectItem>
                  <SelectItem value="Inactif">Inactif</SelectItem>
                  <SelectItem value="Partenaire stratégique">Partenaire stratégique</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Pays *</Label>
              <Input
                value={formData.pays}
                onChange={(e) => setFormData({ ...formData, pays: e.target.value })}
              />
            </div>
            <div>
              <Label>Ville *</Label>
              <Input
                value={formData.ville}
                onChange={(e) => setFormData({ ...formData, ville: e.target.value })}
                placeholder="Conakry"
              />
            </div>
          </div>

          <div>
            <Label>Adresse complète</Label>
            <Input
              value={formData.adresse}
              onChange={(e) => setFormData({ ...formData, adresse: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Site web</Label>
              <Input
                value={formData.site_web}
                onChange={(e) => setFormData({ ...formData, site_web: e.target.value })}
                placeholder="https://..."
              />
            </div>
            <div>
              <Label>Téléphone *</Label>
              <Input
                value={formData.telephone}
                onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Taille entreprise *</Label>
              <Select
                value={formData.taille_entreprise}
                onValueChange={(val) => setFormData({ ...formData, taille_entreprise: val })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="PME">PME</SelectItem>
                  <SelectItem value="ETI">ETI (Entreprise Taille Intermédiaire)</SelectItem>
                  <SelectItem value="Grand compte">Grand compte</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Commercial responsable *</Label>
              <Input
                value={formData.commercial}
                onChange={(e) => setFormData({ ...formData, commercial: e.target.value })}
              />
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4 border-t">
            <Button variant="outline" onClick={onClose}>
              Annuler
            </Button>
            <Button onClick={handleSubmit}>
              Enregistrer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
